export default __webpack_public_path__ + "static/media/opticalscompletedoff.6ab671a7.svg";